import {
  apiV2RuleAlarmLogAlarmAssociatedEntitiesPost,
  V2RuleAlarmLogAlarmAssociatedEntitiesPostResponse,
} from '@maxtropy/device-customer-apis-v2';
import { Button, Modal, Form } from '@maxtropy/components';
import { useNavigate } from 'react-router-dom';
import React, { FC, useEffect, useState } from 'react';
import { isNil } from 'lodash-es';
import { Spin } from 'antd';

interface AssociateLoopsModalProps {
  // visible: boolean;
  visible: (value: boolean) => void;
  displayAssociate: string;
  // onCancel: () => void;
}

const AssociateLoopsModal: FC<AssociateLoopsModalProps> = props => {
  const { visible, displayAssociate } = props;
  const [form] = Form.useForm();
  const [datas, setDatas] = useState<V2RuleAlarmLogAlarmAssociatedEntitiesPostResponse>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  useEffect(() => {
    if (displayAssociate) {
      apiV2RuleAlarmLogAlarmAssociatedEntitiesPost({ id: displayAssociate }).then(res => {
        setDatas(res);
      });
    }
  }, [displayAssociate]);

  return (
    <Modal
      open
      title="查看关联实体"
      size="small"
      onCancel={() => visible(false)}
      footer={[
        <Button key={'cancel'} onClick={() => visible(false)}>
          关闭
        </Button>,
      ]}
    >
      <Spin spinning={isLoading}>
        <Form form={form} layout="horizontal" style={{ padding: '20px' }}>
          <Form.Item label="关联回路">
            <Button
              type="link"
              onClick={() => {
                if (isNil(datas?.circuit?.id)) return;
                window.open(`${window.DMEPLATFORMSORIGIN}/dmes/statistics/circuit?id=${datas?.circuit?.id}`, '_blank');
              }}
            >
              {datas?.circuit?.name ?? '--'}
            </Button>
          </Form.Item>
          <Form.Item label="关联站房">
            <Button
              type="link"
              onClick={() => {
                if (isNil(datas?.room?.id)) return;
                navigate(`/power/station/configuration?stationId=${datas?.room?.id}`);
              }}
            >
              {datas?.room?.name ?? '--'}
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};

export default AssociateLoopsModal;
